import { Link, WarningPanel } from '@backstage/core-components';
import { Text } from '@backstage/ui';

export const EntityNotFound = () => {
  return (
    <WarningPanel
      title="Entity not found"
      message={
        <Text variant="body-small">
          There is no component with the requested{' '}
          <Link to="https://backstage.io/docs/features/software-catalog/references">
            kind, namespace, and name
          </Link>
          . Try adjusting the URL.
        </Text>
      }
      defaultExpanded={true}
    />
  );
};
